import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import state from './state';
import { SET_CARD_CURRENT_EDITED_PLACEMENT } from './mutations';

const buildCardsSettingsActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const setCurrentlyEditedPlacementIndex = buildCardsSettingsActionObject('setCurrentlyEditedPlacementIndex');
export const resetCurrentEditedPlacementIndex = buildCardsSettingsActionObject('resetCurrentEditedPlacementIndex');

const actions = {
	...StoreModuleService.createDefaultActions(),
	[setCurrentlyEditedPlacementIndex.action]({ commit }, payload) {
		// const { fieldId, placementKey } = payload;
		commit(SET_CARD_CURRENT_EDITED_PLACEMENT, payload);
	},
	[resetCurrentEditedPlacementIndex.action]({ dispatch }) {
		Object.keys(state.currentEditedPlacement).forEach((fieldId) => {
			dispatch(setCurrentlyEditedPlacementIndex.action, { fieldId, placementKey: null });
		});
	},
};

export default actions;
